export default "__VITE_ASSET__DL28snf0__"